import { colors } from '@ardoq/design-tokens';
import { opacify, parseToRgb, rgb } from 'polished';
import { RgbColor } from 'polished/lib/types/color';

export const NAVIGATOR_BACKGROUND = colors.grey50;
export const NAVIGATOR_ITEM_ACTIVE_BACKGROUND = colors.white950;
const NAVIGATOR_ITEM_SELECTION_OPACITY = 0.3;
export const NAVIGATOR_ITEM_SELECTION_BACKGROUND = `hsla(210, 100%, 50%, ${NAVIGATOR_ITEM_SELECTION_OPACITY})`;

const flattenChannel = (
  opacity: number,
  foreground: number,
  background: number
) => Math.round(opacity * foreground + (1 - opacity) * background);
const flattenColor = (
  opacity: number,
  foreground: RgbColor,
  background: RgbColor
) =>
  rgb(
    flattenChannel(opacity, foreground.red, background.red),
    flattenChannel(opacity, foreground.green, background.green),
    flattenChannel(opacity, foreground.blue, background.blue)
  );

/** this is the effective selected color, considering the navigator background and the partially transparent selection color above. */
export const NAVIGATOR_ITEM_SELECTED_BACKGROUND_OPAQUE = flattenColor(
  NAVIGATOR_ITEM_SELECTION_OPACITY,
  parseToRgb(opacify(1, NAVIGATOR_ITEM_SELECTION_BACKGROUND)),
  parseToRgb(NAVIGATOR_BACKGROUND)
);

export const NAVIGATOR_TREE_FILTER_ID = 'navigator-tree-filter';
export const NAVIGATOR_TREE_FILTER_BUTTON_ID = 'navigator-tree-filter-button';

export const WORKSPACE_ITEM_CLASS_NAME = 'workspace-item';
export const COMPONENT_ITEM_CLASS_NAME = 'component-item';
export const SCENARIO_ITEM_CLASS_NAME = 'scenario-item';
export const CREATE_COMPONENT_ITEM_CLASS_NAME = 'create-component-item';
export const DRAG_TARGET_CLASS_NAME = 'drag-target';
export const HIGHLIGHTED_CLASS_NAME = 'is-highlighted';

export const COMPONENT_MOUNT_TIMEOUT_MS = 2000; // 2 seconds in ms
// Extended timeout supports the hierarchical "drop-out" view and loader.
// Rationale: Provides superior UX via instant tree-searching compared
// to standard flat lists.
// Strategy: Will iterate on this behavior based on real-world
// performance data and user feedback.
export const COMPONENTS_LOAD_TIMEOUT_MS = 3 * 60 * 1000; // 3 minutes in ms
